module.exports = __webpack_public_path__ + "img/shirt.96473097.svg";